import { Outlet } from "react-router-dom";
import AppSidebar from "@/components/AppSidebar";
import MobileNav from "@/components/MobileNav";
import { ThemeToggle } from "@/components/ThemeToggle";
import { SidebarProvider, SidebarTrigger, SidebarInset } from "@/components/ui/sidebar";
import HelpWidget from "@/help/HelpWidget";

export default function AppLayout() {
  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full">
        <AppSidebar />
        <SidebarInset>
          <header className="sticky top-0 z-40 flex h-14 items-center gap-3 border-b border-border/50 bg-background/80 backdrop-blur-xl px-4 md:px-6">
            <SidebarTrigger className="text-muted-foreground" />
            <div className="flex-1" />
            <ThemeToggle />
          </header>
          <main className="flex-1 pb-20 md:pb-0">
            <Outlet />
          </main>
        </SidebarInset>
        <MobileNav />
        <HelpWidget />
      </div>
    </SidebarProvider>
  );
}
